import React, { SyntheticEvent } from 'react';
import { GameMoveModel } from '../types/GamesModel';
import { useContext } from 'react';
import GameContext from '../context/GameContext';
import { useAppDispatch, useAppSelector } from '../store';
import { setParams } from '../reducers/paramsReducer';
import GamesMoveAlternatives from './GamesMoveAlternatives';
import { usePractice } from './PracticeProvider';

export default function GamesMove(props: {
  move: GameMoveModel;
  onClick?: () => void;
  showAlternatives?: boolean;
}): React.ReactNode {
  const { move, onClick, showAlternatives = true } = props;
  const { chessviewerRef, currentMove } = useContext(GameContext);
  const { color } = useAppSelector((state) => state.paramsReducer.params);
  const practice = usePractice();
  const dispatch = useAppDispatch();
  const yellowClass = move.Pgn == currentMove?.Pgn ? 'yellow' : '';
  const boldClass = color == move.Color ? 'fw-bold' : '';

  const _onClick = (e: SyntheticEvent) => {
    e.preventDefault();
    const chessviewer = chessviewerRef.current;
    if (chessviewer) {
      // A move click is a normal navigation — leave practice first so its prompt/reveal clears and
      // the board doesn't re-arm the solve position on top of the move you picked.
      if (practice.active) {
        practice.stop();
      }
      chessviewer.go(move.Pgn);
      if (onClick) {
        onClick();
      }
    } else {
      dispatch(setParams({ pgn: move.Pgn }));
    }
  };

  return (
    <span className="d-flex flex-row">
      <a
        href="#"
        className={`ps-1 pe-1 me-1 ${yellowClass} ${boldClass}`}
        onClick={_onClick}
        title={move.Pgn}
      >
        {move.NewPosition}
      </a>
      {showAlternatives ? <GamesMoveAlternatives move={move}></GamesMoveAlternatives> : null}
    </span>
  );
}
